export const SET_VERSION = 'SET_VERSION'

export const setVersion = (version: number) => (dispatch: any) => {
  dispatch({
    type: SET_VERSION,
    number: parseInt(`${version}`),
  })
}
